module.exports = __webpack_public_path__ + "img/menu_logo.151c5a95.png";